import { PracticeDifficulty } from '../../../../../gen/graphql';

export const PracticeDifficultyLables: { [key: string]: string } = {
  [PracticeDifficulty.VeryEasy]: 'とても簡単',
  [PracticeDifficulty.Easier]: '簡単',
  [PracticeDifficulty.Normal]: '普通',
  [PracticeDifficulty.Harder]: '難しい',
  [PracticeDifficulty.VeryHard]: 'とても難しい',
} as const;
